// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Password$SmartcutsMacros = require("../Password.bs.js");
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = require("../DomElementIdentifierPaired__WithSelector.bs.js");

function usernamePassword_encode(v) {
  return Js_dict.fromArray([
              [
                "username",
                Decco.stringToJson(v.username)
              ],
              [
                "password",
                Password$SmartcutsMacros.t_encode(v.password)
              ]
            ]);
}

function usernamePassword_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var username = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "username"), null));
  if (username.TAG === /* Ok */0) {
    var password = Password$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "password"), null));
    if (password.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                username: username._0,
                password: password._0
              }
            };
    }
    var e = password._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".password" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = username._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".username" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_encode(v) {
  if (typeof v === "number") {
    return ["NotSelected"];
  } else if (v.TAG === /* NotResolved */0) {
    return [
            "NotResolved",
            Decco.stringToJson(v._0)
          ];
  } else {
    return [
            "Resolved",
            usernamePassword_encode(v._0)
          ];
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "NotResolved" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* NotResolved */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "NotSelected" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotSelected */0
                  };
          }
      case "Resolved" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = usernamePassword_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Resolved */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify(t) {
  if (typeof t === "number") {
    return "NotSelected";
  } else if (t.TAG === /* NotResolved */0) {
    return "NotResolved(" + (t._0 + ")");
  } else {
    return "Resolved(" + (t._0.username + ")");
  }
}

var PasswordForPlayback = {
  usernamePassword_encode: usernamePassword_encode,
  usernamePassword_decode: usernamePassword_decode,
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify
};

function eventSrc_encode(v) {
  if (v) {
    return ["Pasting"];
  } else {
    return ["Typing"];
  }
}

function eventSrc_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Pasting" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Pasting */1
                  };
          }
      case "Typing" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Typing */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "domElementIdentifierWithSelector",
                DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode(v.domElementIdentifierWithSelector)
              ],
              [
                "password",
                Password$SmartcutsMacros.t_encode(v.password)
              ],
              [
                "eventSrc",
                eventSrc_encode(v.eventSrc)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var domElementIdentifierWithSelector = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementIdentifierWithSelector"), null));
  if (domElementIdentifierWithSelector.TAG === /* Ok */0) {
    var password = Password$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "password"), null));
    if (password.TAG === /* Ok */0) {
      var eventSrc = eventSrc_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventSrc"), null));
      if (eventSrc.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  domElementIdentifierWithSelector: domElementIdentifierWithSelector._0,
                  password: password._0,
                  eventSrc: eventSrc._0
                }
              };
      }
      var e = eventSrc._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".eventSrc" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = password._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".password" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = domElementIdentifierWithSelector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".domElementIdentifierWithSelector" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function stringify$1(param) {
  return "{ domElementIdentifierWithSelector: " + (DomElementIdentifierPaired__WithSelector$SmartcutsMacros.stringify(param.domElementIdentifierWithSelector) + (", eventSrc:" + ((
                param.eventSrc ? "Pasting" : "Typing"
              ) + (", password: " + (Password$SmartcutsMacros.obfuscate(param.password) + " }")))));
}

var Recording = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  eventSrc_encode: eventSrc_encode,
  eventSrc_decode: eventSrc_decode,
  stringify: stringify$1
};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "domElementIdentifierWithSelector",
                DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode(v.domElementIdentifierWithSelector)
              ],
              [
                "password",
                t_encode(v.password)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var domElementIdentifierWithSelector = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementIdentifierWithSelector"), null));
  if (domElementIdentifierWithSelector.TAG === /* Ok */0) {
    var password = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "password"), null));
    if (password.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                domElementIdentifierWithSelector: domElementIdentifierWithSelector._0,
                password: password._0
              }
            };
    }
    var e = password._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".password" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = domElementIdentifierWithSelector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".domElementIdentifierWithSelector" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify$2(param) {
  return "{ domElementIdentifierWithSelector: " + (DomElementIdentifierPaired__WithSelector$SmartcutsMacros.stringify(param.domElementIdentifierWithSelector) + (", password: " + (stringify(param.password) + " }")));
}

function updateSelector(f, cmdVal) {
  var domElementIdentifierWithSelector = cmdVal.domElementIdentifierWithSelector;
  return {
          domElementIdentifierWithSelector: {
            domElementIdentifier: domElementIdentifierWithSelector.domElementIdentifier,
            selector: Curry._1(f, domElementIdentifierWithSelector.selector)
          },
          password: cmdVal.password
        };
}

function fromRecording(param) {
  return {
          domElementIdentifierWithSelector: param.domElementIdentifierWithSelector,
          password: /* NotSelected */0
        };
}

var Authoring = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  stringify: stringify$2,
  updateSelector: updateSelector,
  fromRecording: fromRecording
};

var t_encode$3 = t_encode$2;

var t_decode$3 = t_decode$2;

function selectorGet(param) {
  return [param.domElementIdentifierWithSelector.selector];
}

var stringify$3 = stringify$2;

var Playback = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  selectorGet: selectorGet,
  stringify: stringify$3
};

var CommandValue = {
  Recording: Recording,
  Authoring: Authoring,
  Playback: Playback
};

exports.PasswordForPlayback = PasswordForPlayback;
exports.CommandValue = CommandValue;
/* DomElementIdentifierPaired__WithSelector-SmartcutsMacros Not a pure module */
